import { useState } from 'react';

import Modal from '../modal/Modal';
import Gallery from '../gallery/Gallery';
import Main from '../main/Main';
import './content.css';
import UserAppContext from '../../hook/UserAppContext';

const Content = () => {

      const [modal, setModal] = useState(false);
      const [obj, setObj] = useState([]);
      const [page, setPage] = useState(false);
      const {user} = UserAppContext()

      if(user.length === 0) return;

      const {galleries} = user.user;

      return (
            <div className="content">
                  <Modal isModal={modal} isSetModal={setModal} isObj={obj} />
                  <Gallery isSetObj={setObj} galleries={galleries} isSetModal={setModal} isPage={page} isSetPage={setPage} />
                  <Main isSetPage={setPage} />
            </div>
      )
}

export default Content;